import { LCode } from "../../hooks/react-query/settings/linehaul/useLCodes";

export const mockLCodesData: LCode[] = [
  {
    carrierId: 1,
    carrierCode: "L001",
    carrierName: "England CR",
    isActive: true,
    stopOff: 100,
    rollover: 250,
    tonu: 200,
    tonuCancellationWindow: 4,
    detentionFifteenMinIncrement: 15,
    detentionMax: 250,
    detentionFreeTimeHours: 4,
    currentLanes: 200,
  },
  {
    carrierId: 2,
    carrierCode: "L002",
    carrierName: "England CR",
    isActive: true,
    stopOff: 120,
    rollover: 370,
    tonu: 130,
    tonuCancellationWindow: 2,
    detentionFifteenMinIncrement: 10,
    detentionMax: 370,
    detentionFreeTimeHours: 2,
    currentLanes: 150,
  },
  {
    carrierId: 3,
    carrierCode: "L003",
    carrierName: "England CR",
    isActive: true,
    stopOff: 400,
    rollover: 600,
    tonu: 300,
    tonuCancellationWindow: 4,
    detentionFifteenMinIncrement: 15,
    detentionMax: 600,
    detentionFreeTimeHours: 6,
    currentLanes: 300,
  },
  {
    carrierId: 4,
    carrierCode: "L004",
    carrierName: "England CR",
    isActive: true,
    stopOff: 500,
    rollover: 800,
    tonu: 400,
    tonuCancellationWindow: 6,
    detentionFifteenMinIncrement: 15,
    detentionMax: 800,
    detentionFreeTimeHours: 6,
    currentLanes: 400,
  },
  {
    carrierId: 5,
    carrierCode: "L005",
    carrierName: "England CR",
    isActive: true,
    stopOff: 600,
    rollover: 900,
    tonu: 500,
    tonuCancellationWindow: 6,
    detentionFifteenMinIncrement: 15,
    detentionMax: 900,
    detentionFreeTimeHours: 6,
    currentLanes: 500,
  },
  {
    carrierId: 6,
    carrierCode: "L006",
    carrierName: "England CR",
    isActive: true,
    stopOff: 700,
    rollover: 250,
    tonu: 200,
    tonuCancellationWindow: 4,
    detentionFifteenMinIncrement: 15,
    detentionMax: 700,
    detentionFreeTimeHours: 6,
    currentLanes: 600,
  },
  {
    carrierId: 7,
    carrierCode: "L007",
    carrierName: "England CR",
    isActive: true,
    stopOff: 800,
    rollover: 500,
    tonu: 600,
    tonuCancellationWindow: 8,
    detentionFifteenMinIncrement: 15,
    detentionMax: 1000,
    detentionFreeTimeHours: 8,
    currentLanes: 700,
  },
  {
    carrierId: 8,
    carrierCode: "L008",
    carrierName: "England CR",
    isActive: false,
    stopOff: 900,
    rollover: 250,
    tonu: 200,
    tonuCancellationWindow: 4,
    detentionFifteenMinIncrement: 15,
    detentionMax: 250,
    detentionFreeTimeHours: 4,
    currentLanes: 200,
  },
  {
    carrierId: 9,
    carrierCode: "L009",
    carrierName: "England CR",
    isActive: true,
    stopOff: 100,
    rollover: 250,
    tonu: 200,
    tonuCancellationWindow: 4,
    detentionFifteenMinIncrement: 15,
    detentionMax: 250,
    detentionFreeTimeHours: 4,
    currentLanes: 200,
  },
];
